module.exports = __webpack_public_path__ + "img/certificateExport.92fe1d24.svg";